export default __webpack_public_path__ + "static/media/four.1e704411.png";